import { NgModule } from '@angular/core';
import { ImagePipe, TraductionPipe, CutTextPipe, CustomDatePipe, FormatSecondPipe, GetDayPipe, HourMinutePipe, HourMinuteSecPipe, SafePipe, ShowValueSeparatPipe, GrdFilterPipe, SafeHtmlPipe, LearnerSortPipe, DayOfQueovalDatePipe, NumberOfQueovalYearPipe, NumberOfQueovalDayPipe, MonthOfQueovalDatePipe, StringifyPipe, MoneyPipe, TraductionPipeAsync, QDatePipe, SecondToHour } from './core.pipe';

@NgModule({
  imports: [

  ],
  declarations: [
    TraductionPipe,
    TraductionPipeAsync,
    ImagePipe,
    CutTextPipe,
    CustomDatePipe,
    FormatSecondPipe,
    GetDayPipe,
    DayOfQueovalDatePipe,
    MonthOfQueovalDatePipe,
    NumberOfQueovalDayPipe,
    NumberOfQueovalYearPipe,
    HourMinutePipe,
    HourMinuteSecPipe,
    SafePipe,
    SafeHtmlPipe,
    ShowValueSeparatPipe,
    GrdFilterPipe,
    LearnerSortPipe,
    StringifyPipe,
    MoneyPipe,
    QDatePipe,
    SecondToHour,
  ],
  exports: [
    TraductionPipe,
    TraductionPipeAsync,
    ImagePipe,
    CutTextPipe,
    CustomDatePipe,
    FormatSecondPipe,
    GetDayPipe,
    DayOfQueovalDatePipe,
    MonthOfQueovalDatePipe,
    NumberOfQueovalDayPipe,
    NumberOfQueovalYearPipe,
    HourMinutePipe,
    HourMinuteSecPipe, 
    SafePipe,
    SafeHtmlPipe,
    ShowValueSeparatPipe,
    GrdFilterPipe,
    LearnerSortPipe,
    StringifyPipe,
    MoneyPipe,
    QDatePipe,
    SecondToHour,
  ]
})

export class PipeModule { }
